<template>
  <rp-permissions :requireAll="['read_messages']">
    <div v-if="show" class="sidebar-links">
      <router-link to="/messages" exact>All Messages</router-link>
      <router-link :to="{ name: 'Received Messages', query: { 'important': true }}" exact>Important Messages</router-link>
      <router-link :to="{ name: 'Received Messages', query: { 'archived': true }}" exact>Archived Messages</router-link>
      <rp-permissions  :requireOne="['admin_write_messages', 'write_messages']">
        <router-link :to="{ name: 'Sent Messages' }" exact>Sent Messages</router-link>
        <router-link :to="{ name: 'Compose Message' }" exact>Compose Message</router-link>
      </rp-permissions>
    </div>
  </rp-permissions>
</template>

<script>
import Permissions from 'raypro_ui/src/components/Permissions'

export default {
  components: {'rp-permissions': Permissions},

  computed: {
    path() {
      return this.$route.path
    },

    show() {
      return new RegExp('/messages').test(this.path) ||
      new RegExp('/compose-message').test(this.path) ||
      new RegExp('/sent-messages').test(this.path)
    }
  }
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/SideNav/MessagesLinks.vue